import React from "react";
import { Redirect } from "react-router-dom";

interface Props {}

const Home: React.FC<Props> = (props: Props) => {
  return <Redirect to={{ pathname: "/profile" }} />;
};

export default Home;
